import $ from "jquery";

const wappHeader = () => {

    const target = ".elementor-nav-menu--dropdown";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };



    const exec = () => {
        $target.append($('#buttonSocialIcon').html());

        $('.elementor-nav-menu--dropdown .button-reserveran .elementor-button-text').text("Reserveran");
    };

    init();
};

try {
    wappHeader();
} catch (error) {
    throw Error(error);
}

